import React, { FC, Dispatch, SetStateAction } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'
import { useSelector } from 'react-redux'
import { isAuthenticated } from 'selectors/user/session'

type Props = {
  shouldLoadComponent: boolean
  setShouldLoadComponent: Dispatch<SetStateAction<boolean>>
}
const RecentlyViewedCarousel = dynamic(
  import(
    /* webpackChunkName: "RecentlyViewedCarouselPLP" */
    './Carousel'
  ),
  noSSR
)

const RecentlyViewed: FC<Props> = (props) => {
  const { shouldLoadComponent, setShouldLoadComponent } = props
  /* Replacing connector */
  const authenticated = useSelector(isAuthenticated)
  /* ============================================================== */
  if (!authenticated) {
    return null
  }

  return (
    <RecentlyViewedCarousel
      shouldLoadComponent={shouldLoadComponent}
      setShouldLoadComponent={setShouldLoadComponent}
    />
  )
}

export default RecentlyViewed
